/* ASC-CUSTOM (Atelier design demo, 2026-09-24): product page top.
   1. Hangs the "made to order / in 1–3 business days" gift tag from the bottom edge of the main photo (placed right after
      the main slider, so it never sits inside the swiper's clipped box and never covers the thumbnails).
   2. The rating link scrolls to the reviews ("on their walls" part of sections/asc-at-pdp-lower.liquid, else Judge.me). */
(function () {
  'use strict';
  function hang() {
    /* desktop gallery (.thumbnail-media--main-media) and phone slider (.product-media-slider-main) are separate elements;
       each gets its own tag, only the visible one shows */
    var mains = document.querySelectorAll('.product-single .product-media-slider-desktop .thumbnail-media--main-media, .product-single .product-media-slider-mobile .product-media-slider-main');
    Array.prototype.forEach.call(mains, function (main) {
      if (main.nextElementSibling && main.nextElementSibling.classList.contains('at-pdp-hangwrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'at at-pdp-hangwrap';
      wrap.innerHTML = '<div class="at-hang"><b>made to order</b>in 1–3 business days</div>';
      main.parentNode.insertBefore(wrap, main.nextSibling);
    });
  }
  function reviews() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-at-to-reviews]');
      if (!a) return;
      var t = document.querySelector('[id^="at-pdpl-walls-"]') || document.getElementById('judgeme_product_reviews');
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  /* 2026-10-08: asc-at-head.liquid keeps room for the builder until it renders; if none shows 8 s after load
     (script blocked or slow, a product without a config), the room goes away */
  function lpoLate() {
    function wait() {
      setTimeout(function () {
        if (!document.querySelector('.cl-po--option')) document.documentElement.classList.add('asc-lpo-late');
      }, 8000);
    }
    if (document.readyState === 'complete') wait(); else window.addEventListener('load', wait);
  }
  /* 2026-10-09 (ads audit FN-F2): the phone "Personalize yours" button scrolls to the builder (the reserved card until it
     renders) and fades while the builder is on screen, so only one call to action shows at a time */
  function start() {
    var b = document.querySelector('[data-at-start]');
    if (!b) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function target() { return document.querySelector('product-information .cl-po--wrapper') || document.querySelector('product-information .paymentButtonsWrapper'); }
    b.addEventListener('click', function () {
      var t = target();
      if (!t) return;
      t.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      try { if (window.asc && window.asc.track) window.asc.track('pdp_start_click', {}, { once: true }); } catch (e) {}
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { b.classList.toggle('is-quiet', en.isIntersecting); });
    }, { rootMargin: '0px 0px -50% 0px' });  /* quiet only once the builder reaches the upper half of the screen */
    var n = 0;
    (function watch() {
      var w = document.querySelector('product-information .cl-po--wrapper');
      if (w) io.observe(w); else if (++n < 40) setTimeout(watch, 250);
    })();
  }
  /* Squishy tiles (library card 765136d68bc61b89 "squishy tuşlar"; 27 Oct press only, 28 Oct Murat: "seçilince kutunun
     genişlemesi diğerlerinin küçülmesi gerekmiyor mu?"). In a single row of 2–5 text tiles the chosen tile is wider and the
     others give way, as in Material 3 button groups. Pressing a tile moves the width to it at once, so the press itself
     shows, and choosing it keeps it there. Image tiles and 2×2 / 3×2 grids are left alone. The other tiles never get
     narrower than their own words; a row where some tile would gain under 5 px when chosen (the four sizes on a 360 px
     phone gain about 1; "None" of the markers on a 375 px phone gains 5.6) keeps the stylesheet's equal columns, and a
     press pushes the tile in a little instead.
     - The stylesheet writes columns as repeat(n, …), which browsers do not tween, so a row gets written-out columns the
       first time it is set up and keeps them.
     - On touch nothing moves until the finger lifts without having travelled, so a scroll that starts on a tile (even
       after resting on it) never swings the row; the mouse previews on press.
     - Reduced motion: the chosen tile is still wider, nothing slides (the transitions live in asc-at-pdp-top.css). */
  function squish() {
    var GROW = [0, 0, 1.5, 1.45, 1.4, 1.4], MIN_GAIN = 5, SLOP = 10, PRESS_MS = 140, UNDO_MS = 450;
    var hold = null, epoch = 0, queued = false, cv = document.createElement('canvas').getContext('2d');
    /* width a tile needs for its words on one line (the "Most popular" badge floats above the tile and is not counted) */
    function need(tile) {
      var btn = tile.querySelector('.cl-po--swatch-button') || tile, cs = getComputedStyle(btn), w = 0;
      var walk = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT), node;
      while ((node = walk.nextNode())) {
        var t = node.nodeValue.trim(), el = node.parentElement;
        if (!t || !el || el.closest('.asc-sw__badge')) continue;
        var s = getComputedStyle(el);
        cv.font = s.fontStyle + ' ' + s.fontWeight + ' ' + s.fontSize + ' ' + s.fontFamily;
        w = Math.max(w, cv.measureText(t).width + (parseFloat(s.letterSpacing) || 0) * t.length);
      }
      return w + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth) + 4;
    }
    /* grid-template-columns for the row with tile `pick` widened (-1: none); null when the words do not fit or the
       chosen tile would gain under MIN_GAIN. Mirrors the grid's own share-out: a tile whose share is below its words keeps
       its words' width and the others share what is left. */
    function columns(row, info, pick) {
      var n = info.n, mins = info.mins, avail = row.clientWidth - (n - 1) * info.gap, w = [], fixed = [], total = 0, f = 0, k;
      for (k = 0; k < n; k++) { w.push(k === pick ? GROW[n] : 1); fixed.push(false); total += mins[k]; }
      if (total > avail) return null;
      if (pick >= 0) {
        for (var again = true; again;) {
          var rest = avail, ws = 0;
          for (k = 0; k < n; k++) if (fixed[k]) rest -= mins[k]; else ws += w[k];
          if (!ws) break;
          f = rest / ws; again = false;
          for (k = 0; k < n; k++) if (!fixed[k] && w[k] * f < mins[k]) fixed[k] = again = true;
        }
        if (fixed[pick] || w[pick] * f - avail / n < MIN_GAIN) return null;
      }
      return w.map(function (x, k) { return 'minmax(' + mins[k] + 'px,' + x + 'fr)'; }).join(' ');
    }
    /* which rows take part, measured once per screen width (a resize or the web fonts arriving measure again) */
    function rowInfo(row) {
      var items = Array.prototype.filter.call(row.children, function (c) { return c.offsetParent !== null; });
      var key = epoch + ':' + window.innerWidth + ':' + items.length, info = row.__ascInfo;
      if (row.__ascKey === key && (!info || info.items.every(function (c) { return c.parentNode === row; }))) return info;
      info = null;
      var n = items.length;
      if (n >= 2 && n <= 5 && !row.querySelector('img') && items.every(function (c) { return c.classList.contains('cl-po--swatch-item'); })) {
        var keep = row.style.gridTemplateColumns;
        if (keep) row.style.gridTemplateColumns = '';  /* the stylesheet's own columns: a row it wraps into a grid stays out */
        var cs = getComputedStyle(row);
        if (cs.display === 'grid' && cs.gridTemplateColumns.split(' ').length === n) {
          info = { items: items, n: n, gap: parseFloat(cs.columnGap) || 0, mins: items.map(function (c) { return Math.ceil(need(c)); }) };
          info.wide = items.every(function (c, k) { return columns(row, info, k) !== null; });  /* every tile widens, or none */
        }
        if (keep) row.style.gridTemplateColumns = keep;
      }
      row.__ascKey = key; row.__ascInfo = info;
      return info;
    }
    /* set a row's columns; pick undefined = the chosen tile. mode 'init' sets a new row without a slide (page load, a row
       that just appeared), 'press' uses the quicker press timing. Returns 'wide', 'flat' (cannot widen) or null (not a row) */
    function sync(row, pick, mode) {
      var info = rowInfo(row);
      if (!info || !info.wide) {
        if (row.__ascSet) { row.style.gridTemplateColumns = ''; row.__ascSet = false; }
        return info ? 'flat' : null;
      }
      if (pick === undefined) { pick = -1; info.items.forEach(function (c, k) { if (c.querySelector('input:checked')) pick = k; }); }
      if (!row.__ascSet && mode !== 'init') {
        row.style.gridTemplateColumns = columns(row, info, -1);
        void getComputedStyle(row).gridTemplateColumns;  /* commit equal written-out columns, so the next change can tween */
      }
      row.classList.toggle('at-squish', mode === 'press');
      row.style.gridTemplateColumns = columns(row, info, pick);
      row.__ascSet = true;
      return 'wide';
    }
    function syncAll(mode) {
      Array.prototype.forEach.call(document.querySelectorAll('product-information .cl-po--swatch-container'), function (r) {
        if (!hold || hold.row !== r) sync(r, undefined, mode);
      });
    }
    function later(mode) {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncAll(mode); });
    }
    function unpress(h) {
      if (hold && hold !== h && hold.item === h.item && hold.shown) return;  /* a newer, visible press on the same tile */
      h.item.classList.remove('is-pressed', 'is-pushed');
      h.row.classList.remove('at-squish');
    }
    function show() {
      var h = hold;
      if (!h || h.shown) return;
      h.shown = true; h.t0 = Date.now();
      h.item.classList.add('is-pressed');
      if (sync(h.row, h.pick, 'press') === 'flat') h.item.classList.add('is-pushed');
    }
    /* the press is over: the chosen tile decides the row again (when the tap chose the pressed tile, nothing moves) */
    function end() {
      var h = hold;
      if (!h) return;
      hold = null;
      clearTimeout(h.undo);
      if (!h.up) { clearTimeout(h.unpress); unpress(h); }
      if (h.shown) sync(h.row, undefined, 'change');
    }
    document.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      var it = e.target.closest && e.target.closest('product-information .cl-po--swatch-item');
      if (!it) return;
      var inp = it.querySelector('input');  /* a choice that cannot be picked (photo-book paper, is-off) does not press */
      if (it.classList.contains('is-off') || (inp && inp.disabled)) return;
      var row = it.parentElement;
      if (!row || !row.classList.contains('cl-po--swatch-container')) return;
      var info = rowInfo(row), i = info ? info.items.indexOf(it) : -1;
      if (i < 0) return;
      end();
      hold = { row: row, item: it, pick: i, pid: e.pointerId, x: e.clientX, y: e.clientY, t0: Date.now(), shown: false, up: false, unpress: 0, undo: 0 };
      if (e.pointerType !== 'touch') show();
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {  /* a finger that travels is scrolling or dragging, not choosing */
      var h = hold;
      if (!h || h.shown || h.up || e.pointerId !== h.pid) return;
      if (Math.abs(e.clientX - h.x) > SLOP || Math.abs(e.clientY - h.y) > SLOP) { hold = null; unpress(h); }  /* clears a quick earlier tap's press too */
    }, { passive: true });
    document.addEventListener('pointerup', function (e) {
      var h = hold;
      if (!h || h.up || (e.pointerId !== undefined && e.pointerId !== h.pid)) return;  /* another finger lifting */
      h.up = true;
      show();  /* touch: the tap is confirmed now */
      h.unpress = setTimeout(function () { unpress(h); }, Math.max(0, PRESS_MS - (Date.now() - h.t0)));
      h.undo = setTimeout(function () { if (hold === h) end(); }, UNDO_MS);  /* no choice followed (dragged off the tile) */
    }, { passive: true });
    document.addEventListener('pointercancel', function (e) {  /* the finger started a scroll */
      if (hold && (e.pointerId === undefined || e.pointerId === hold.pid)) end();
    }, { passive: true });
    window.addEventListener('blur', end);
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('product-information')) return;
      if (hold && hold.up && hold.row.contains(e.target)) end();
      later('change');  /* LPO may show or hide rows for this choice */
    }, true);
    var root = document.querySelector('product-information') || document.body;
    if (window.MutationObserver) new MutationObserver(function () { later('init'); }).observe(root, { childList: true, subtree: true });
    window.addEventListener('resize', function () { later('init'); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { epoch++; later('init'); });
    later('init');
  }
  function init() { hang(); reviews(); lpoLate(); start(); squish(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
